export default __webpack_public_path__ + "static/media/4.7eea32b7.jpg";